import { forwardRef } from 'react';
import styled from 'styled-components';
import { ModalTransitionContextProvider } from 'foundations-components/transitional/components/Modal/ModalTransitionContext';
import { jsx as _jsx } from "react/jsx-runtime";
const InnerMeasure = styled.span.attrs({
  'aria-hidden': true
}).withConfig({
  displayName: "HiddenMeasure__InnerMeasure",
  componentId: "sc-190qeos-0"
})([".hs-private.hs-private.hs-private &{overflow:hidden;position:absolute;left:0;max-width:100%;visibility:hidden;pointer-events:none;}"]);

// We want to force popovers to stay closed, so we use ModalTransitionContext to tell popovers that
// they're in a transitioning modal. Weird but effective!
const hidePopoversContextValue = {
  transitioning: true
};
const HiddenMeasure = /*#__PURE__*/forwardRef((props, ref) => /*#__PURE__*/_jsx(ModalTransitionContextProvider, {
  value: hidePopoversContextValue,
  children: /*#__PURE__*/_jsx(InnerMeasure, Object.assign({}, props, {
    ref: ref
  }))
}));
export default HiddenMeasure;